if(!customElements.get('cart-section')){
    class CartSection extends HTMLElement {
        constructor() {
            super();
            this.CartItems = this.querySelector('cart-items')
            this.Initialize()
        }

        // Listen For Theme Events. Refetch Html For Page from the Text Delivered by the Event
        cartUpdateUnsubscriber = undefined;
    
        connectedCallback() {
            this.cartUpdateUnsubscriber = SubscribeToEvent('PopulateCart', (eventData) => {
                this.OnCartUpdated(eventData);
            });
        }
    
        disconnectedCallback() {
            if (this.cartUpdateUnsubscriber) {
                this.cartUpdateUnsubscriber();
            }
        }
    
        OnCartUpdated(eventData) {
            this.PopulateCart(eventData)
        }
        Initialize() {

        }
        PopulateCart(text, openOverlay = true) {
            try {
                const html = new DOMParser().parseFromString(text, 'text/html');
                const CartSection = html.querySelector('#CartSection');
                this.innerHTML = CartSection.parentElement.innerHTML;
            } catch (error) {
                console.error('Populate Cart Error:', error);
            }
            // Conditionally Render Overlay
            if (openOverlay) {
                theme?.Overlay?.ActivateLayer('CartLayer')
            }
            
        }
        
    }
    customElements.define('cart-section', CartSection);
}
if(!customElements.get('cart-item')){
    class CartItem extends HTMLElement {
        constructor() {
            super();
            this.IncreaseButton = this.querySelector('[data-increase]')
            this.DecreaseButton = this.querySelector('[data-decrease]')
            this.AmountInput = this.querySelector('[data-amount-input]')
            this.RemoveButton = this.querySelector('[data-remove]')
            // this.LineItemId = this.dataset.lineItemId
            // this.VariantId = parseInt(this.dataset.variantId)
            // this.TotalQuantity = parseInt(this.dataset.cartCount)
            this.LineQuantity = parseInt(this.dataset.lineAmount)
            this.LineIndex = parseInt(this.dataset.index)
            this.Initialize()
        }

        Initialize() {
            if (this.LineIndex && this.LineQuantity) {
                this.RemoveButton.addEventListener('click', (event) => this.RemoveLineItem(event))
                this.DecreaseButton.addEventListener('click', (event) => this.DecreaseCount(event))
                this.IncreaseButton.addEventListener('click', (event) => this.IncreaseCount(event))
                this.AmountInput?.addEventListener('change', (event) => this.SetAmount(event))
            }
        }
        async ChangeCartItem(number) {
            const LineIndex = this.LineIndex
            if (LineIndex) {
                this.dataset.state = 'Loading'
                try {
                    const res = await fetch('/cart/change.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept': 'application/json'
                        },
                        body: JSON.stringify({
                            line: LineIndex,
                            quantity: number
                        })
                    })
                    if (!res.ok) {
                        // TODO NOTIFICATION ERROR HANDLING
                        console.log(await res.text())
                        throw new Error(`Network response was not ok`);
                    } else {
                        const response = await res.json()
                        TriggerEvent('UpdateCart', response)
                    }
                } catch (error) {
                    console.log(`ChangeCartItem Error: ${error.message}`, error )
                } finally {
                    this.dataset.state = 'InActive'
                }
            }
        }
        RemoveLineItem(event) {
            this.ChangeCartItem(0)
        }
        DecreaseCount(event) {
            this.ChangeCartItem(this.LineQuantity - 1)
        }
        IncreaseCount(event) {
            this.ChangeCartItem(this.LineQuantity + 1)
        }
        SetAmount(event) {
            const Value = event.target.value
            if (Value) {
                this.ChangeCartItem(Value)
            }
        }
    }
    customElements.define('cart-item', CartItem);
}

if (!customElements.get('cart-note')) {
    class CartNote extends HTMLElement {
        constructor() {
            super();
        }
        connectedCallback() {
            this.Initialize()
        }
        Initialize() {
            this.addEventListener('change',
                debounce((event) => {
                    const body = JSON.stringify({ note: event.target.value });
                    fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
                })
            );
        }
    }
    customElements.define('cart-note', CartNote)
}